<template>
	<by-container :showLoading="showLoading" :showNotContent="showNotContent" bgColor="#f0f0f0">
		<div class="wrap clearfloat">
			<div class="search">
				<input
					type="text"
					name=""
					id="expressNo"
					v-model="search"
					placeholder="请输入站点快递单号"
				/>
				<button class="search-btn" type="button" id="expressBtn" @click="getDetail">查快递</button>
			</div>

			<div class="time-line-body" id="time-line" v-if="activities.length > 0">
				<el-timeline >
					<el-timeline-item
						v-for="(activity, index) in activities"
						:key="index"
						:icon="activity.icon"
						:color="activity.color"
						:size="activity.size"
						:timestamp="activity.createTime"
					>
						{{ activity.detail }}
					</el-timeline-item>
				</el-timeline>
			</div>
			<div v-else class="no_data">暂未搜索</div>
		</div>
	</by-container>
</template>

<script>
export default {
	components: {
		// 引入组件
	},
	data() {
		return {
			showLoading: false, //页面加载状态
			showNotContent: false, //是否显示空

			search: "",
			activities: [],
		};
	},
	props: {
		// 上级页面传递的数据
	},
	computed: {
		// 计算属性
	},
	created() {
		// 实例初始化
	},
	beforeCreate() {
		// 实例初始化之后
	},
	mounted() {
		// 实例被挂载后调用
	},
	updated() {
		// 数据更新后调用
	},
	activated() {
		// 缓存页面显示后调用
	},
	deactivated() {
		// 缓存页面隐藏后调用
	},
	methods: {
		getDetail() {
			let reqInfo = {};
			reqInfo.expressNo = this.search;
			if (!this.search) return this.$tool.tipsFun.msgError("请输入快递号");
			this.showLoading = true;
			this.$api.Home.getExpressDetail(
				reqInfo,
				res => {
					this.showLoading = false;
					this.activities = res.data.logs;
				},
				err => {
					this.showLoading = false;
					this.$tool.tipsFun.msgError(err);
				}
			);
		},
	},
	watch: {
		// 数据监听及回调
	},
};
</script>

<style scoped="scoped">
.no_data{
	padding: 10px;
	box-sizing: border-box;
	background: #fff;
	margin-bottom: 20px;
}
.search {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	background-color: #ffffff;
	margin: 30px 0;
	padding: 10px 20px;
}
.search input {
	width: 100%;
	height: 40px;
	border: 0;
	padding: 0 15px;
	background-color: #f8f8f8;
}
.search-btn {
	background-color: #ff8664;
	width: 150px;
	height: 40px;
	margin-left: 15px;
	border: 0;
	color: #ffffff;
}

.time-line-body {
	background-color: #ffffff;
	padding: 15px 20px;
	margin-bottom: 30px;
}
</style>
